import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// Magic link callbacks are no longer used — auth is Google-only.
// Any incoming /login/callback URL is redirected to /login.
export function LoginCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/login', { replace: true })
  }, [navigate])

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
    </div>
  )
}
